import {
  ADD_B_FILTERS,
  ADD_N_FILTERS,
  RESET_ALL_FILTERS,
  SET_PET_FRIENDLY_SELECTED,
  SET_RESULTS_APPLIED_SORT,
  TOGGLE_B_FILTER,
  TOGGLE_PET_FRIENDLY_SELECTED,
  UPDATE_MAX_VALUE,
  UPDATE_MIN_VALUE,
} from './action-types';

export const resetAllFilters = (dispatch) => {
  dispatch({ type: RESET_ALL_FILTERS });
};

export const toggleBFilter = (dispatch, value) => {
  dispatch({ type: TOGGLE_B_FILTER, payload: Number(value) });
};
export const addBFilters = (dispatch, values) => {
  dispatch({ type: ADD_B_FILTERS, payload: values });
};

export const addNFilters = (dispatch, values) => {
  dispatch({ type: ADD_N_FILTERS, payload: values });
};

export const togglePetFriendlySelected = (dispatch) => {
  dispatch({ type: TOGGLE_PET_FRIENDLY_SELECTED });
};
export const setPetFriendlySelected = (dispatch, value) => {
  dispatch({ type: SET_PET_FRIENDLY_SELECTED, payload: value });
};

export const updateMinValue = (dispatch, payload) => {
  dispatch({ type: UPDATE_MIN_VALUE, payload });
};

export const updateMaxValue = (dispatch, payload) => {
  dispatch({ type: UPDATE_MAX_VALUE, payload });
};
export const setResultsAppliedSort = (dispatch, value) => {
  dispatch({ type: SET_RESULTS_APPLIED_SORT, payload: value });
};
